import { IAppConfig } from './types';

function loadStaticModules(appConfig: IAppConfig) {
  require('/Users/edy/Desktop/广西/recept-pc/node_modules/build-plugin-ice-request/lib/runtime.js').default(
    { appConfig }
  );
}

export default loadStaticModules;
